import React from 'react';
import { DateRangeSelect } from '@shared/UI';
import { SearchInput } from '@features/SearchInput';
import { useTransactionsTable } from '../../lib';
import './TransactionsTableFilters.scss';
import { formats } from '@shared/utils';

export const TransactionsTableFilters: React.FC = () => {
    const { setTransactionsIdentifier, setCusip, dateRange, setDateRange } = useTransactionsTable();

    return (
        <div className='widget-trade-status-table-filters'>
            <SearchInput
                setValue={setTransactionsIdentifier}
                placeholder='Symbol and Cusip'
            />
            <DateRangeSelect
                currentValue={dateRange}
                format={formats.dateWithYear}
                firstPlaceholder={'Select Date'}
                dropdownPlacement='bottom-left'
                allowClear
                onDateRangeSelect={setDateRange}
            />
        </div>
    );
};
